<template>
	<div>
		<header>
			<h1>Campaigns</h1>
			<div>
				<ul>
					<li><router-link
						:to="{name: 'campaigns.create'}"
						class="button button--primary--small">Create Campaign</router-link>
					</li>
				</ul>
			</div>
		</header>
		<div>
			<section v-if="!loaded">
				<loader/>
			</section>
			<template v-if="loaded">
				<div class="sections--flexed">
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Active </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="stats.active"></span>
						</p>
						<button class="button button--secondary--small metrics__metric--number__button">View</button>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Stopped </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="stats.stopped"></span>
						</p>
						<button class="button button--secondary--small metrics__metric--number__button">View</button>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Scheduled </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="stats.scheduled"></span>
						</p>
						<button class="button button--secondary--small metrics__metric--number__button">View</button>
					</section>
				</div>
				<table-filter :filters="filters"/>
				<div v-if="loaded && !items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<article
					v-for="(item, index) in items"
					v-if="loaded && items.length"
					class="section section--expanded sections--flexed campaign-summary">
					<section class="section section--borderless">
						<header>
							<h1 class="beta" v-html="item.name"/>
							<div>
								<v-contextual>
									<v-contextual-option
										:route-to="{name: 'campaigns.show', params: {campaign: item.id}}">View</v-contextual-option>
									<v-contextual-option
										v-if="$can('update', item)"
										:route-to="{name: 'campaigns.edit', params: {campaign: item.id}}">Edit</v-contextual-option>
									<v-contextual-option
										v-if="$can('start', item)"
										@click="start(item)">Start</v-contextual-option>
									<v-contextual-option
										v-if="$can('stop', item)"
										@click="stop(item)">Stop</v-contextual-option>
								</v-contextual>
							</div>
						</header>
						<dl class="detail-list">
							<div class="detail-list__item">
								<dt>Introducer</dt>
								<dd v-html="item.introducer.profile.name"/>
							</div>
							<div class="detail-list__item">
								<dt>Service</dt>
								<dd v-html="item.service.names.plural"/>
							</div>
							<div class="detail-list__item">
								<dt>Recipient</dt>
								<dd v-html="item.recipient.profile.name"/>
							</div>
							<div class="detail-list__item">
								<dt>Call Centre</dt>
								<dd v-if="!item.callCentre">—</dd>
								<dd v-if="item.callCentre" v-html="item.callCentre.profile.name"/>
							</div>
						</dl>
					</section>
					<div class="sections sections--flexed campaign-summary__charts">
						<section class="section section--borderless metrics__metric--number">
							<p class="metrics__metric__stats">
								<span class="metrics__metric__stats__title">Leads </span>
								<span class="metrics__metric__stats__value" v-html="totalLeads(item)"></span>
							</p>
						</section>
						<section class="section section--borderless metrics__metric--number">
							<p class="metrics__metric__stats">
								<span class="metrics__metric__stats__title">Declined Leads </span>
								<span class="metrics__metric__stats__value" v-html="declinedLeads(item)"></span>
							</p>
						</section>
						<section class="section section--borderless metrics__metric--number">
							<p class="metrics__metric__stats">
								<span class="metrics__metric__stats__title">Days </span>
								<span class="metrics__metric__stats__value" v-html="days(item)"></span>
							</p>
						</section>
						<hr>
						<section v-if="leads(item).length" class="section section--borderless metrics__metric--status">
							<header class="sr-only">
								<h2 class="beta">Leads by Status</h2>
							</header>
							<div>
								<div class="metrics__metric--status__diagram">
									<span
										v-for="(status, statusIndex) in leadsStatuses(item)" :class="barClass(status)"
										:style="barStyle(status, item)"></span>
								</div>
								<dl class="metrics__metric__key">
									<div v-for="(label, status) in $enum('LeadStatusEnum').display()" :class="status">
										<span :class="barClass(status)"></span>
										<div class="metrics__metric__key__data">
											<dt class="metrics__metric__key__data__title" v-html="label"/>
											<dd
												class="metrics__metric__key__data__figure"
												v-html="leadsByStatus(leads(item), status).length"/>
											<dd class="metrics__metric__key__data__figure">{{ leadPercentage(leadsByStatus(leads(item), status), leads(item)) }}%</dd>
										</div>
									</div>
								</dl>
							</div>
						</section>
					</div>
				</article>
			</template>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions, mapMutations} = createNamespacedHelpers("campaigns");

export default {
	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"meta",
			"stats",
			"query",
			"filters",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
			"filter",
		]),
		...mapActions([
			"updateModel",
		]),
		activeSplit(campaign) {
			let self = this;

			return _.find(campaign.splits, function (split) {
				return self.$enum("CampaignSplitStatusEnum").getKey("running") === split.status;
			});
		},
		leads(campaign) {
			let activeCampaign = this.activeSplit(campaign);

			return activeCampaign
				? activeCampaign.leads
				: _.flatMap(campaign.splits, function (split) {
					return split.leads;
				});
		},
		totalLeads(campaign) {
			return this.leads(campaign).length;
		},
		declinedLeads(campaign) {
			let self = this;

			return _.filter(this.leads(campaign), function (lead) {
				return self.$enum("LeadStatusEnum").getKey("declined") === lead.status;
			}).length;
		},
		days(campaign) {
			let activeCampaign = this.activeSplit(campaign);
			let start = moment(activeCampaign
				? activeCampaign.start_at
				: campaign.created_at).startOf("day");
			let end = moment().endOf("day");

			return moment.duration(end.diff(start)).days();
		},
		start(campaign) {
			http().patch("campaigns/" + campaign.id + "/start", "api").then(response => {
				this.updateModel(response.data.data);
				this.$store.dispatch("alertsStore/success", "Campaign Started");
			});
		},
		stop(campaign) {
			http().patch("campaigns/" + campaign.id + "/stop", "api").then(response => {
				this.updateModel(response.data.data);
				this.$store.dispatch("alertsStore/success", "Campaign Stopped");
			});
		},
		leadsStatuses(campaign) {
			let statuses = this.$enum("LeadStatusEnum").getKeys();

			return _.orderBy(_.uniq(_.map(this.leads(campaign), function (lead) {
				return lead.status;
			})), function (status, key) {
				return statuses.indexOf(status);
			}, "asc");
		},
		leadsByStatus(leads, status) {
			return _.filter(leads, function (lead) {
				return lead.status === status;
			});
		},
		barClass(status) {
			return "badge--" + status;
		},
		barStyle(status, campaign) {
			return {
				width: this.leadPercentage(this.leadsByStatus(this.leads(campaign), status), this.leads(campaign)) + "%",
			};
		},
		leadPercentage(leadsByStatus, leads) {
			return Math.round((leadsByStatus.length / leads.length) * 100, 2);
		},
	},

	created() {
		this.getModels();
	},
};
</script>
